import { render, staticRenderFns } from "./POIEditDialog.vue?vue&type=template&id=2fbc67f1"
import script from "./POIEditDialog.js?vue&type=script&lang=js&external"
export * from "./POIEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports